/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';
import { RepdashWindowRef } from '@experience/repdash/interfaces/repdash.interface';
import { CustomerDetailsResponse } from '@support/api/proxies/responses/api-2007.interface';
import { OrderSearchResults } from '@experience/repdash/interfaces/order-profile.interface';
/**
 * Service that holds a reference of window
 *
 * And have window/document specific functions
 *
 *
 *
 * @export
 * @class WindowRefService
 */
/* tslint:disable:no-any*/
@Injectable()
export class RepdashStoreUtilsService {
  /**
   * Reference to window.
   *
   * @private
   * @type {Window}
   * @memberof WindowRefService
   */
  private readonly windowRef: RepdashWindowRef;

  constructor() {
    this.windowRef = window;
  }
  /**
   * Function to get rep dash store lookup tab
   * @returns string
   */
  public getRepdashStoreLookupTab(data: string): string {
    return this.getDate(data);
  }

  /**
   * Function to get rep dash order lookup response
   * @param {string} keyName
   * @returns OrderSearchResults
   */
  public getRepdashStoreOrderLookupData(keyName: string): OrderSearchResults[] {
    return this.getDate(keyName);
  }

  /**
   * Function to get rep dash store auth token
   * @returns string
   */
  public getRepdashStoreAuthToken(data: string): string {
    return this.getDate(data);
  }

  /**
   * Function to get rep dash store auth token
   * @returns string
   */
  public getlineOfServiceId(data: string): string {
    return this.getDate(data);
  }

  /**
   * Function to get rep dash store active customer id
   * @returns string
   */
  public getRepdashStoreActiveCustomerId(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash store active account id
   * @returns string
   */
  public getRepdashStoreActiveAccountId(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash store active bscs id
   * @returns string
   */
  public getRepdashStoreActiveBscsId(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash store order Id
   * @returns string
   */
  public getRepdashStoreOrderId(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash store client state
   * @returns string
   */
  public getRepdashStoreNavigateClientState(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash store dealerCode
   * @returns string
   */
  public getRepdashStoreDealerCode(data: string): string {
    return this.getDate(data);
  }
  /**
   * Function to get rep dash application userid
   * @returns string
   */

  public getRepdashApplicationUserId(data: string): string {
    return this.getDate(data);
  }

  /**
   * Function to get rep dash application userid
   * @returns string
   */

  public getRepdashPermissionRole(data: string): string {
    return this.getDate(data);
  }

  public getPermissionObject(data: string): string {
    return this.getDate(data);
  }

  public getInteractionId(data: string): string {
    return this.getDate(data);
  }

  public getMacAddress(data: string): string {
    return this.getDate(data);
  }
  public getRepdashStoreMsisdn(data: string): string {
    return this.getDate(data);
  }
  public getProfileId(data: string): string {
    return this.getDate(data);
  }
  public getcustomerDetailsResponse(data: string): CustomerDetailsResponse {
    return this.getDate(data);
  }

  public getDate(data: any): any {
    if (this.windowRef.RepdashStore) {
      return this.windowRef.RepdashStore.stateStore.getState(data);
    }
  }

  public setData(path: string, data: any): any {
    if (this.windowRef.RepdashStore) {
      return this.windowRef.RepdashStore.stateStore.setState(path, data);
    }
  }

  public setCustomerDataInState(path: string, data: any): any {
    return this.setData(path, data);
  }
}
